var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C6 1.17188 5.32812 0.5 4.5 0.5H1.5C0.671875 0.5 0 1.17188 0 2V5C0 5.82812 0.671875 6.5 1.5 6.5H4.5C5.32812 6.5 6 5.82812 6 5V2ZM6 10C6 9.17188 5.32812 8.5 4.5 8.5H1.5C0.671875 8.5 0 9.17188 0 10V13C0 13.8281 0.671875 14.5 1.5 14.5H4.5C5.32812 14.5 6 13.8281 6 13V10ZM8 2V5C8 5.82812 8.67188 6.5 9.5 6.5H12.5C13.3281 6.5 14 5.82812 14 5V2C14 1.17188 13.3281 0.5 12.5 0.5H9.5C8.67188 0.5 8 1.17188 8 2ZM14 10C14 9.17188 13.3281 8.5 12.5 8.5H9.5C8.67188 8.5 8 9.17188 8 10V13C8 13.8281 8.67188 14.5 9.5 14.5H12.5C13.3281 14.5 14 13.8281 14 13V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareGrid);
export default __webpack_public_path__ + "static/media/square-grid.5b79636b944320ab7710db4a89d0a8fe.svg";
export { ForwardRef as ReactComponent };